import { FC, HTMLAttributes } from 'react';

import { Button } from 'antd';

import HamburgerIcon from 'assets/images/hamburger.svg?react';
import { useSidebarSlice } from 'widgets/Sidebar';

interface IHamburgerProps extends HTMLAttributes<HTMLButtonElement> {}

export const Hamburger: FC<IHamburgerProps> = ({ className }) => {
	const { opened, toggleOpened } = useSidebarSlice();

	return (
		<Button
			className={className}
			type={opened ? 'primary' : 'text'}
			shape="circle"
			size="small"
			icon={<HamburgerIcon />}
			onClick={() => toggleOpened()}
		/>
	);
};
